const config = {
  stage: process.env.REACT_APP_STAGE_ENV || 'dev',
  axios: {
    baseURL: process.env.REACT_APP_API_BASE_URL || '',
    coreApiUrl: process.env.REACT_APP_CORE_API_URL || 'http://localhost:4000',
    socketUrl: process.env.REACT_APP_SOCKET_API_URL || 'ws://localhost:4000',
    prefix: process.env.REACT_APP_PREFIX_API_URL || '/api/v1',
  },
  chat: {
    facebook: {
      appId: process.env.REACT_APP_FACEBOOK_APP_ID || '6006340816160333',
      configurations: {
        pages: process.env.REACT_APP_FACEBOOK_PAGES_CONFIG_ID || '178071358527819',
        instagram: process.env.REACT_APP_FACEBOOK_IG_CONFIG_ID || '642973997347518',
      },
    },
  },
};
export default config;
